(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-hero"] && !Shopify.designMode) return;
  try {
    
  // dot-matrix world motif — same land mask as the origin map, rendered
  // as pure texture (no markers, no arcs, no interaction).
  // S121 perf: painted ONCE into a canvas bitmap (one element, one draw)
  // instead of 4,786 SVG circle nodes, and built during idle time AFTER
  // first paint so it never competes with the statement reveal.
  (function () {
    var box = document.querySelector('[data-about-map]');
    if (!box) return;
    var idle = window.requestIdleCallback || function (f) { setTimeout(f, 180); };
    var tries = 0;

    function draw() {
      if (!window.LOOT_WORLD_DOTS) {
        if (tries++ < 40) return setTimeout(draw, 100);
        return;
      }
      var W = 2000, H = 840, SCALE = 2; // 2x backing keeps dots crisp
      var canvas = document.createElement('canvas');
      canvas.width = W * SCALE;
      canvas.height = H * SCALE;
      var ctx = canvas.getContext('2d');
      ctx.scale(SCALE, SCALE);
      ctx.globalAlpha = 0.15;
      ctx.fillStyle = getComputedStyle(box).color || '#000';
      ctx.beginPath();
      window.LOOT_WORLD_DOTS.forEach(function (bits, r) {
        var cy = r * 10 + 5;
        if (cy > H) return;
        for (var c = 0; c < bits.length; c++) {
          if (bits.charAt(c) !== '1') continue;
          var cx = c * 10 + 5;
          ctx.moveTo(cx + 1.7, cy);
          ctx.arc(cx, cy, 1.7, 0, 6.2832);
        }
      });
      ctx.fill();
      box.appendChild(canvas);
      requestAnimationFrame(function () {
        canvas.classList.add('is-on');
      });
    }

    idle(function () { draw(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-drop-gate"]) return;
  try {
    
  (function () {
    var gate = document.querySelector('[data-drop-gate]');
    if (!gate) return;
    document.addEventListener('loot:drop-live', function () {
      var until = Number(gate.getAttribute('data-drop-gate-until')) * 1000;
      if (!until || Date.now() < until) return;
      var pre = gate.querySelector('[data-drop-prelive]');
      var post = gate.querySelector('[data-drop-postlive]');
      if (pre) pre.hidden = true;
      if (post) post.hidden = false;
    });
  })();

  // Teaser video: honor prefers-reduced-motion, else the same iOS autoplay
  // armor as the cinema hero (S119) so it never falls back to a play glyph.
  (function () {
    var v = document.querySelector('.drop-gate__media');
    if (!v || v.tagName !== 'VIDEO') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      v.removeAttribute('autoplay');
      v.pause();
      return;
    }
    v.defaultMuted = true;
    v.muted = true;
    function kick() {
      if (!v.paused) return;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    kick();
    ['touchstart', 'click', 'scroll'].forEach(function (ev) {
      window.addEventListener(ev, kick, { once: true, passive: true });
    });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) kick();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    var catalog = document.querySelector('[data-catalog]');
    if (!catalog) return;

    /* sticky util-bar offset = live header height (the ticker may or may
       not be present, and its close button changes the height) */
    var headerGroup = document.querySelector('.shopify-section-group-header-group');
    var utilBar = catalog.querySelector('.util-bar');
    function setUtilTop() {
      if (!headerGroup) return;
      catalog.style.setProperty('--util-top', headerGroup.getBoundingClientRect().height + 'px');
      if (utilBar) catalog.style.setProperty('--util-bar-h', utilBar.getBoundingClientRect().height + 'px');
    }
    setUtilTop();
    window.addEventListener('resize', setUtilTop);
    if (window.ResizeObserver) {
      if (headerGroup) new ResizeObserver(setUtilTop).observe(headerGroup);
      if (utilBar) new ResizeObserver(setUtilTop).observe(utilBar);
    }

    // IMG \ TXT view toggle, persisted
    var KEY = 'loot:catalog-view';
    var btns = catalog.querySelectorAll('[data-view-btn]');
    function setView(view) {
      catalog.setAttribute('data-view', view);
      btns.forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-view-btn') === view);
      });
      try { localStorage.setItem(KEY, view); } catch (e) {}
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () { setView(b.getAttribute('data-view-btn')); });
    });
    try {
      var saved = localStorage.getItem(KEY);
      if (saved === 'txt') setView('txt');
    } catch (e) {}

    // filter panel — inline expand/collapse, non-modal
    var panel = catalog.querySelector('[data-panel]');
    var toggleBtn = catalog.querySelector('[data-panel-toggle]');
    if (!panel || !toggleBtn) return;

    function setOpen(open) {
      panel.classList.toggle('is-open', open);
      toggleBtn.setAttribute('aria-expanded', String(open));
    }

    toggleBtn.addEventListener('click', function () {
      setOpen(!panel.classList.contains('is-open'));
    });
    panel.querySelectorAll('[data-panel-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { setOpen(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) setOpen(false);
    });

    // applying filters reloads the page — the panel stays closed so the
    // filtered grid is the first thing the reader sees (owner, S95)

    // type-to-find inside long filter groups
    panel.querySelectorAll('[data-filter-find]').forEach(function (input) {
      var rows = input.parentElement.querySelectorAll('.catalog__filter-row');
      input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase();
        rows.forEach(function (row) {
          var name = row.querySelector('.catalog__filter-name');
          var hit = !q || (name && name.textContent.toLowerCase().indexOf(q) !== -1);
          row.classList.toggle('is-found-hidden', !hit);
        });
      });
    });

    // filters apply ONLY via the APPLY button (owner, S91) — no
    // auto-submit on change, no price debounce
    var filterForm = panel.querySelector('[data-filter-form]');
    if (filterForm) {
      // empty inputs would litter the URL with hollow params — clean on submit
      filterForm.addEventListener('submit', function () {
        filterForm.querySelectorAll('input').forEach(function (i) {
          if (i.type !== 'checkbox' && i.type !== 'radio' && i.value === '') i.disabled = true;
        });
      });
    }

    // size chips navigate the tag path — keep the current filter query
    panel.querySelectorAll('[data-size-chip]').forEach(function (chip) {
      chip.addEventListener('click', function (e) {
        e.preventDefault();
        window.location.href = chip.getAttribute('href') + window.location.search;
      });
    });

    // expand/collapse long value lists (expansion widens into columns)
    panel.querySelectorAll('[data-filter-more]').forEach(function (btn) {
      var group = btn.closest('.catalog__filter-group');
      var values = group.querySelector('[data-filter-values]');
      btn.addEventListener('click', function () {
        var expanded = values.classList.toggle('is-expanded');
        group.classList.toggle('is-expanded', expanded);
        btn.textContent = btn.getAttribute(expanded ? 'data-label-less' : 'data-label-more');
      });
    });

    // live inventory search — Shopify predictive search API in the panel
    var searchForm = panel.querySelector('[data-predictive]');
    var resultsBox = panel.querySelector('[data-predictive-results]');
    if (searchForm && resultsBox) {
      var searchInput = searchForm.querySelector('input[type=search]');
      var debounceTimer = null;
      var controller = null;

      function esc(s) {
        var d = document.createElement('div');
        d.textContent = s || '';
        return d.innerHTML;
      }

      function render(products, q) {
        if (!products.length) {
          resultsBox.innerHTML = '<p class="catalog__result--empty">> 0 RESULTS_</p>';
          resultsBox.hidden = false;
          return;
        }
        var html = products.map(function (p) {
          var img = p.featured_image && p.featured_image.url
            ? '<img class="catalog__result-thumb" src="' + p.featured_image.url + '&width=120" alt="" loading="lazy">'
            : '';
          return '<a class="catalog__result" href="' + p.url + '">' + img +
            '<span class="catalog__result-title">' + esc(p.title).toUpperCase() + '</span>' +
            '<span class="catalog__result-price">' + esc(p.price) + '</span></a>';
        }).join('');
        html += '<a class="catalog__result catalog__result--all" href="/search?q=' + encodeURIComponent(q) + '&type=product">' +
          (resultsBox.getAttribute('data-view-all') || 'VIEW ALL RESULTS') + ' →</a>';
        resultsBox.innerHTML = html;
        resultsBox.hidden = false;
      }

      searchInput.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        var q = searchInput.value.trim();
        if (q.length < 2) {
          resultsBox.hidden = true;
          resultsBox.innerHTML = '';
          return;
        }
        debounceTimer = setTimeout(function () {
          if (controller) controller.abort();
          controller = new AbortController();
          fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6', { signal: controller.signal })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              var products = (data.resources && data.resources.results && data.resources.results.products) || [];
              render(products, q);
            })
            .catch(function () {});
        }, 220);
      });
    }
    // cursor thumbnail — TXT rows carry data-preview; a fixed frame follows
    // the pointer and swaps to the hovered product's image. Direct follow
    // (no lerp): it reads as an instrument readout, not decoration.
    var tbody = catalog.querySelector('.catalog__table tbody');
    var preview = catalog.querySelector('.catalog__preview');
    if (tbody && preview && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var previewImg = preview.querySelector('img');
      var OFFSET = 14;

      function placePreview(x, y) {
        var w = preview.offsetWidth;
        var h = preview.offsetHeight;
        var left = x + OFFSET;
        if (left + w > window.innerWidth - 8) left = x - w - OFFSET;
        var top = Math.max(8, Math.min(y - h / 2, window.innerHeight - h - 8));
        preview.style.transform = 'translate(' + left + 'px,' + top + 'px)';
      }

      tbody.addEventListener('mouseover', function (e) {
        var tr = e.target.closest('tr');
        if (!tr || !tr.hasAttribute('data-preview')) return;
        if (!Loot.preview.set(previewImg, tr)) return;
        preview.hidden = false;
        placePreview(e.clientX, e.clientY);
      });
      tbody.addEventListener('mousemove', function (e) {
        if (!preview.hidden) placePreview(e.clientX, e.clientY);
      });
      tbody.addEventListener('mouseleave', function () { preview.hidden = true; });
    }

    /* infinite inventory — pages are prefetched before they're needed and
       appended items reveal per-piece as they enter the viewport, so the
       catalog streams instead of popping 50-item chunks. The pagination
       nav stays in the DOM as the no-JS fallback. */
    var sentinel = catalog.querySelector('[data-sentinel]');
    if (sentinel) {
      var pgnav = catalog.querySelector('.catalog__pagination');
      if (pgnav) pgnav.hidden = true;
      var sentinelText = sentinel.querySelector('[data-sentinel-text]');
      var toTop = sentinel.querySelector('[data-to-top]');
      if (toTop) {
        toTop.addEventListener('click', function () {
          var lenis = window.Loot && Loot.scroll && Loot.scroll.instance;
          if (lenis) lenis.scrollTo(0);
          else window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }
      var grid = catalog.querySelector('.catalog__grid');
      var tableBody = catalog.querySelector('.catalog__table tbody');
      var nextPage = 2;
      var loading = false;
      var done = false;
      var buffered = null;

      /* appended pieces fade/rise one by one, same grammar as Loot.reveal */
      var revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-faded-in');
          // reveal nested faders too — boot-registered Loot.reveal never
          // sees streamed elements (the wardrobe learned this the hard way)
          entry.target.querySelectorAll('[data-fade]').forEach(function (el) {
            el.classList.add('is-faded-in');
          });
          revealIO.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px' });

      function fetchPage(n) {
        var u = new URL(window.location.href);
        u.searchParams.set('page', n);
        /* no-store: Safari serves stale cached page fetches across deploys */
        return fetch(u.toString(), { credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            return {
              items: doc.querySelectorAll('.catalog__grid > li:not(.catalog__empty)'),
              rows: doc.querySelectorAll('.catalog__table tbody tr')
            };
          });
      }

      /* the next page is always in flight before the reader reaches it */
      function prefetch() {
        if (done || buffered) return;
        fetchPage(nextPage)
          .then(function (data) { buffered = data; })
          .catch(function () {});
      }

      function appendBuffered() {
        if (!buffered) return;
        if (!buffered.items.length) {
          done = true;
          if (sentinelText) sentinelText.textContent = sentinelText.getAttribute('data-end') || 'END OF INVENTORY';
          if (toTop) toTop.hidden = false;
          io.disconnect();
          return;
        }
        buffered.items.forEach(function (li) {
          // WebKit trap: DOMParser-adopted nodes misbehave in Safari (lazy
          // imgs never load) — re-serialize into the live document so every
          // element is born normal (same fix as the wardrobe stream)
          grid.insertAdjacentHTML('beforeend', li.outerHTML);
          var live = grid.lastElementChild;
          live.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
            img.removeAttribute('loading');
          });
          revealIO.observe(live);
        });
        if (tableBody) {
          buffered.rows.forEach(function (tr) {
            tableBody.insertAdjacentHTML('beforeend', tr.outerHTML);
          });
        }
        buffered = null;
        nextPage++;
        if (window.Loot && Loot.preview) Loot.preview.warm(); // new rows' thumbs
        if (window.Loot && Loot.dropgate) Loot.dropgate.refresh();
        prefetch();
        /* keep filling while the sentinel sits near the viewport — the
           observer won't re-fire on its own if we never left it */
        var sr = sentinel.getBoundingClientRect();
        if (!done && sr.top < window.innerHeight * 1.55) stream();
      }

      function stream() {
        if (loading || done) return;
        if (buffered) { appendBuffered(); return; }
        loading = true;
        if (sentinelText) sentinelText.textContent = '···';
        fetchPage(nextPage)
          .then(function (data) {
            buffered = data;
            loading = false;
            appendBuffered();
          })
          .catch(function () { loading = false; });
      }

      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) stream();
      }, { rootMargin: '0px 0px 55% 0px' });
      io.observe(sentinel);
      prefetch(); // page 2 starts loading at boot
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
  // custom HUD listbox — replaces the OS-native dropdown popup (unthemeable)
  // with an in-house one. Built from the rendered <option>s, so labels stay
  // localized; the native select keeps the value for form submission.
  (function () {
    var select = document.getElementById('ct-subject');
    if (!select) return;
    var wrap = select.closest('.contact__select-wrap');
    if (!wrap) return;

    var dd = document.createElement('div');
    dd.className = 'contact__dd';

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'contact__dd-trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    var label = document.createElement('span');
    label.textContent = select.selectedOptions[0] ? select.selectedOptions[0].textContent : '';
    trigger.appendChild(label);

    var caret = wrap.querySelector('.contact__select-caret');
    if (caret) {
      var c = caret.cloneNode(true);
      c.classList.add('contact__dd-caret');
      trigger.appendChild(c);
    }

    var list = document.createElement('ul');
    list.className = 'contact__dd-list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;

    function open() {
      list.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      dd.classList.add('is-open');
      document.addEventListener('click', onDocClick, true);
    }
    function close() {
      list.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      dd.classList.remove('is-open');
      document.removeEventListener('click', onDocClick, true);
    }
    function onDocClick(e) {
      if (dd.contains(e.target)) return;
      // swallow the outside click entirely: it closes the list and nothing
      // else — an open dropdown can never trigger SEND (or any other control)
      e.preventDefault();
      e.stopPropagation();
      close();
    }

    Array.prototype.slice.call(select.options).forEach(function (opt, i) {
      var li = document.createElement('li');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'contact__dd-option';
      btn.setAttribute('role', 'option');
      btn.setAttribute('aria-selected', String(opt.selected));
      btn.innerHTML =
        '<span class="contact__dd-index">' + ('0' + (i + 1)).slice(-2) + '</span>' +
        '<span class="contact__dd-text"></span>' +
        '<span class="contact__dd-current" aria-hidden="true">●</span>';
      btn.querySelector('.contact__dd-text').textContent = opt.textContent;
      btn.addEventListener('click', function () {
        select.value = opt.value;
        label.textContent = opt.textContent;
        list.querySelectorAll('.contact__dd-option').forEach(function (b) {
          b.setAttribute('aria-selected', 'false');
        });
        btn.setAttribute('aria-selected', 'true');
        close();
        trigger.focus();
      });
      li.appendChild(btn);
      list.appendChild(li);
    });

    trigger.addEventListener('click', function () {
      if (list.hidden) { open(); } else { close(); }
    });

    dd.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); trigger.focus(); return; }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      e.preventDefault();
      if (list.hidden) { open(); return; }
      var items = list.querySelectorAll('.contact__dd-option');
      var idx = Array.prototype.indexOf.call(items, document.activeElement);
      var next = e.key === 'ArrowDown' ? idx + 1 : idx - 1;
      if (next < 0) next = items.length - 1;
      if (next >= items.length) next = 0;
      items[next].focus();
    });

    dd.appendChild(trigger);
    dd.appendChild(list);
    wrap.appendChild(dd);
    wrap.classList.add('has-custom-dd');
    select.classList.add('contact__select--hidden');
    select.setAttribute('aria-hidden', 'true');
    select.tabIndex = -1;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var v = document.querySelector('.hero__media');
    if (!v) return;

    // reduced motion: the film holds on its poster frame instead of playing
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      v.removeAttribute('autoplay');
      v.pause();
      return;
    }

    // iOS declines autoplay in Low Power Mode (and sometimes on first
    // paint) — belt and braces: assert mutedness the way WebKit checks
    // it, try immediately, and retry on the first touch/scroll and when
    // the tab regains visibility. The native play glyph is hidden in
    // CSS, so a refusal shows the poster, never a button.
    v.defaultMuted = true;
    v.muted = true;
    function kick() {
      if (!v.paused) return;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    kick();
    ['touchstart', 'click', 'scroll'].forEach(function (ev) {
      window.addEventListener(ev, kick, { once: true, passive: true });
    });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) kick();
    });
  })();

  // header watcher (S137c): the band is background-less while the
  // page's white fills it scroll-locked; hero-filled arms the solid
  // bar only once the fill completes. Ink flips at the band midline.
  (function () {
    var hero = document.querySelector('.hero');
    if (!hero) return;
    function headerH() {
      var h = document.querySelector('.site-header');
      return h ? h.getBoundingClientRect().height : 0;
    }
    function paint() {
      var y = window.scrollY;
      var H = hero.offsetHeight;
      var hh = headerH();
      document.body.classList.toggle('hero-filled', y >= H);
      // ink flips just before the rising white reaches the glyphs'
      // bottoms — never a white-on-white instant; dark ink reads fine
      // on the light film above the fill line
      document.body.classList.toggle('over-hero', y < H - hh * 0.62);
    }
    paint();
    window.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', paint);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-cinema"] && !Shopify.designMode) return;
  try {
    
  // milliseconds ride on the cinema countdowns only (owner S131b):
  // a third segment appended to the shared snippet's time row, driven
  // by rAF (auto-pauses in background tabs). Loot.countdown hides the
  // whole time row at T-0, taking the ms with it. Reduced motion: no
  // ms — a 60fps flicker is exactly what those users opted out of.
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var spans = [];
    document.querySelectorAll('.cinema__drop-timer .countdown__time').forEach(function (time) {
      var sep = document.createElement('span');
      sep.className = 'countdown__sep';
      sep.setAttribute('aria-hidden', 'true');
      sep.textContent = ':';
      var ms = document.createElement('span');
      ms.className = 'countdown__seg cinema__ms';
      ms.textContent = '00';
      // the snippet's own separators carry markup whitespace around the
      // colon — mirror it, so the ms segment spaces exactly like the rest
      time.appendChild(document.createTextNode(' '));
      time.appendChild(sep);
      time.appendChild(document.createTextNode(' '));
      time.appendChild(ms);
      spans.push({ time: time, ms: ms });
    });
    if (!spans.length) return;
    function frame() {
      var v = String(Math.floor((999 - (Date.now() % 1000)) / 10)).padStart(2, '0');
      var alive = false;
      spans.forEach(function (s) {
        if (s.time.hidden) return;
        s.ms.textContent = v;
        alive = true;
      });
      if (alive) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  })();

  (function () {
    var v = document.querySelector('.cinema__media');
    if (!v) return;
    // S147d (owner: "it must ALWAYS just autoplay" on iPhone): the film
    // now plays under prefers-reduced-motion too — a deliberate owner
    // override of the site-wide reduced-motion rule for this one ambient,
    // muted film (the homepage IS the film; a frozen poster reads broken).
    // iOS armor (S119, hardened S147): pageshow covers bfcache restores,
    // the glyph shield covers any refusal; S147d widens the armor —
    // muted set BEFORE any play attempt, a retry ladder on the media's
    // own readiness events plus a capped interval (iOS play() can reject
    // transiently mid-load), and a gesture net that includes touchend +
    // pointerdown (scroll never fires on this fixed page; Low Power Mode
    // only ever unlocks on a real gesture, so the FIRST touch must land).
    var stage = v.closest('.cinema');
    v.addEventListener('playing', function () {
      if (stage) stage.classList.add('is-rolling');
    });
    v.addEventListener('pause', function () {
      if (stage) stage.classList.remove('is-rolling');
    });
    v.defaultMuted = true;
    v.muted = true;
    v.setAttribute('muted', '');
    function kick() {
      if (!v.paused) return;
      v.muted = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    function arm() {
      ['touchstart', 'touchend', 'pointerdown', 'click', 'scroll'].forEach(function (ev) {
        window.addEventListener(ev, kick, { once: true, passive: true });
      });
    }
    kick();
    arm();
    // retry ladder: the media's own readiness beats any timer…
    ['loadedmetadata', 'loadeddata', 'canplay', 'canplaythrough'].forEach(function (ev) {
      v.addEventListener(ev, kick);
    });
    // …but a capped interval sweeps up transient rejections (8 tries / 4s)
    var tries = 0;
    var sweep = setInterval(function () {
      if (!v.paused || tries++ >= 8) { clearInterval(sweep); return; }
      kick();
    }, 500);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) kick();
    });
    window.addEventListener('pageshow', function () {
      kick();
      arm();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-inventory-band"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('.inv-band');
    var preview = section && section.querySelector('.inv-band__preview');
    if (!preview || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var previewImg = preview.querySelector('img');
    var OFFSET = 14;

    function placePreview(x, y) {
      var w = preview.offsetWidth;
      var h = preview.offsetHeight;
      var left = x + OFFSET;
      if (left + w > window.innerWidth - 8) left = x - w - OFFSET;
      var top = Math.max(8, Math.min(y - h / 2, window.innerHeight - h - 8));
      preview.style.transform = 'translate(' + left + 'px,' + top + 'px)';
    }

    section.querySelectorAll('[data-preview]').forEach(function (el) {
      el.addEventListener('mouseenter', function (e) {
        if (!Loot.preview.set(previewImg, el)) return;
        preview.hidden = false;
        placePreview(e.clientX, e.clientY);
      });
      el.addEventListener('mousemove', function (e) {
        if (!preview.hidden) placePreview(e.clientX, e.clientY);
      });
      el.addEventListener('mouseleave', function () { preview.hidden = true; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-looks"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-konsole]');
    if (!root) return;

    var tabs = root.querySelectorAll('[data-konsole-tab]');
    var panes = root.querySelectorAll('[data-konsole-pane]');
    var current = 1;
    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var leavingPane = null;
    var SWAP_MS = 800; // GL transition duration — pin entrances wait for it

    /* ── tech panel: radar scope + telemetry + oscilloscope ── */
    var SVG_NS = 'http://www.w3.org/2000/svg';
    var tech = root.querySelector('[data-konsole-tech]');
    var techCoord = tech && tech.querySelector('[data-tech-coord]');

    function fmtCoord(v, pos, neg, pad) {
      var parts = Math.abs(v).toFixed(2).split('.');
      var i = parts[0];
      while (i.length < pad) i = '0' + i;
      return i + '.' + parts[1] + (v >= 0 ? pos : neg);
    }

    /* dot matrix — NERV channel display with a warp morph: on switch the
       dots first burst into a formation (wave / rings / terrain /
       scatter), then resolve into the new channel number. */
    var matrixBox = tech && tech.querySelector('[data-tech-matrix]');
    var mdots = [];
    var MDOT_COUNT = 54;
    var morphTimer = null;
    var DIGITS = {
      '0': [7, 5, 5, 5, 7], '1': [2, 6, 2, 2, 7], '2': [7, 1, 7, 4, 7],
      '3': [7, 1, 7, 1, 7], '4': [5, 5, 7, 1, 1], '5': [7, 4, 7, 1, 7],
      '6': [7, 4, 7, 5, 7], '7': [7, 1, 1, 1, 1], '8': [7, 5, 7, 5, 7],
      '9': [7, 5, 7, 1, 7]
    };
    var WARPS = [
      function (i, n) { var t = i / (n - 1); return [6 + t * 88, 50 + Math.sin(t * Math.PI * 3) * 26]; },
      function (i, n) {
        var ring = i < n / 2 ? 16 : 32;
        var a = (i / (n / 2)) * Math.PI * 2 + (ring === 32 ? 0.3 : 0);
        return [50 + Math.cos(a) * ring * 1.35, 50 + Math.sin(a) * ring];
      },
      function (i, n) {
        var col = i % 9, row = Math.floor(i / 9);
        return [10 + col * 10, 92 - (Math.sin(col * 1.7) * 0.5 + 0.5) * 55 - row * 9];
      },
      function (i, n) { return [8 + ((i * 37) % 84), 10 + ((i * 61) % 80)]; },
    ];

    function buildMatrix() {
      if (!matrixBox) return;
      for (var i = 0; i < MDOT_COUNT; i++) {
        var d = document.createElement('i');
        d.className = 'konsole__tech-mdot' + (i >= 30 && (i - 30) % 6 === 0 ? ' konsole__tech-mdot--accent' : '');
        d.style.left = '50%';
        d.style.top = '50%';
        matrixBox.appendChild(d);
        mdots.push(d);
      }
    }

    /* halo formations around the digit — a different one per look:
       circle / square frame / corner brackets / diamond */
    function placeHalo(paneIdx, i) {
      var j = i - 30; // 0..23
      var variant = (paneIdx - 1) % 4;
      if (variant === 0) {
        var a = (j / 24) * Math.PI * 2 - Math.PI / 2;
        return [50 + Math.cos(a) * 40, 50 + Math.sin(a) * 36];
      }
      if (variant === 1) {
        // square frame, 6 dots per side
        var side = Math.floor(j / 6), k = j % 6;
        if (side === 0) return [12 + k * 15.2, 12];
        if (side === 1) return [88, 12 + k * 15.2];
        if (side === 2) return [88 - k * 15.2, 88];
        return [12, 88 - k * 15.2];
      }
      if (variant === 2) {
        // corner brackets — 2x3 clusters at the four corners
        var corner = Math.floor(j / 6), c = j % 6;
        var cx = corner % 2 === 0 ? 12 : 88;
        var cy = corner < 2 ? 14 : 86;
        return [cx + (c % 3) * (corner % 2 === 0 ? 5 : -5), cy + Math.floor(c / 3) * (corner < 2 ? 7 : -7)];
      }
      // diamond, 6 dots per edge
      var es = Math.floor(j / 6), ek = j % 6;
      var pts = [[50, 12], [88, 50], [50, 88], [12, 50]];
      var p0 = pts[es], p1 = pts[(es + 1) % 4];
      var t = ek / 6;
      return [p0[0] + (p1[0] - p0[0]) * t, p0[1] + (p1[1] - p0[1]) * t];
    }

    function placeDigit(paneIdx) {
      var num = ('0' + paneIdx).slice(-2);
      mdots.forEach(function (d, i) {
        var x, y;
        if (i < 30) {
          var digitIdx = Math.floor(i / 15);
          var cell = i % 15;
          var ch = num[digitIdx];
          var col = cell % 3;
          var row = Math.floor(cell / 3);
          var on = DIGITS[ch][row] & (4 >> col);
          x = (digitIdx === 0 ? 18 : 52) + col * 11;
          y = 24 + row * 10.5;
          d.style.opacity = on ? '' : '0.12';
        } else {
          var halo = placeHalo(paneIdx, i);
          x = halo[0];
          y = halo[1];
          d.style.opacity = '';
        }
        d.style.transitionDelay = (i * 9) + 'ms';
        d.style.left = x + '%';
        d.style.top = y + '%';
      });
    }

    function morphMatrix(paneIdx) {
      // phase 1: burst into this look's warp formation
      var fn = WARPS[(paneIdx - 1) % WARPS.length];
      mdots.forEach(function (d, i) {
        var xy = fn(i, MDOT_COUNT);
        d.style.opacity = '';
        d.style.transitionDelay = (i * 6) + 'ms';
        d.style.left = xy[0] + '%';
        d.style.top = xy[1] + '%';
      });
      // phase 2: resolve into the channel number
      if (morphTimer) clearTimeout(morphTimer);
      morphTimer = setTimeout(function () {
        placeDigit(paneIdx);
        morphTimer = null;
      }, 650);
    }

    function techUpdate(pane) {
      if (!tech) return;
      var lat = parseFloat(pane.getAttribute('data-tech-lat'));
      var lon = parseFloat(pane.getAttribute('data-tech-lon'));
      var cc = pane.getAttribute('data-tech-cc');
      var latV = tech.querySelector('[data-tech-lat-v]');
      var lonV = tech.querySelector('[data-tech-lon-v]');
      var railMeta = root.querySelector('.konsole__rail-meta');
      var railLat = root.querySelector('[data-rail-lat]');
      var railLon = root.querySelector('[data-rail-lon]');
      if (!cc || isNaN(lat)) {
        if (latV) latV.textContent = '··';
        if (lonV) lonV.textContent = '··';
        if (railLat) { railLat.textContent = '··'; railLat.setAttribute('data-decode-text', '··'); }
        if (railLon) { railLon.textContent = '··'; railLon.setAttribute('data-decode-text', '··'); }
        return;
      }
      var latText = fmtCoord(lat, 'N', 'S', 2);
      var lonText = fmtCoord(lon, 'E', 'W', 3);
      if (latV) { latV.textContent = latText; latV.setAttribute('data-decode-text', latText); }
      if (lonV) { lonV.textContent = lonText; lonV.setAttribute('data-decode-text', lonText); }
      /* rail mirrors the telemetry — the panel itself stays hidden */
      if (railLat) { railLat.textContent = latText; railLat.setAttribute('data-decode-text', latText); }
      if (railLon) { railLon.textContent = lonText; railLon.setAttribute('data-decode-text', lonText); }
      if (railMeta && window.Loot && Loot.decode && Loot.decode.burst) Loot.decode.burst(railMeta);
      var objEl = tech.querySelector('[data-tech-obj]');
      var camEl = tech.querySelector('[data-tech-cam]');
      var paneIdx = parseInt(pane.getAttribute('data-konsole-pane'), 10) || 1;
      if (objEl) {
        var n = pane.querySelectorAll('.konsole__row').length;
        var objText = ('0' + n).slice(-2);
        objEl.textContent = objText;
        objEl.setAttribute('data-decode-text', objText);
      }
      if (camEl) {
        var camText = 'CAM_0' + (paneIdx + 1);
        camEl.textContent = camText;
        camEl.setAttribute('data-decode-text', camText);
      }
      if (techCoord) {
        var text = cc + ' LOCKED';
        techCoord.textContent = text;
        techCoord.setAttribute('data-decode-text', text);
      }
      if (techVisuals) {
        morphMatrix(paneIdx);
        scopeSeed = 0.7 + paneIdx * 0.5;
        if (scopeCtx) scopeInit();
      }
      if (window.Loot && Loot.decode && Loot.decode.burst) Loot.decode.burst(tech);
    }

    /* data ribbon — two rows of bit blocks scrolling left, re-seeded per
       look; geometric, always transmitting */
    var scope = tech && tech.querySelector('[data-tech-scope]');
    var scopeCtx = scope && scope.getContext ? scope.getContext('2d') : null;
    var scopeCols = 28;
    var scopeGrid = [];
    var scopeSeed = 1.2;
    var scopeTick = 0;

    function scopeRandom(col) {
      // deterministic-ish bit columns, re-seeded per look
      var bits = 0;
      for (var r = 0; r < 2; r++) {
        if (Math.random() < 0.42 * scopeSeed && Math.random() > 0.18) bits |= (1 << r);
      }
      return bits;
    }

    function scopeInit() {
      scopeGrid = [];
      for (var c = 0; c < scopeCols; c++) scopeGrid.push(scopeRandom(c));
    }

    function drawScope() {
      var w = scope.width, h = scope.height;
      var cw = w / scopeCols;
      scopeTick++;
      if (scopeTick % 6 === 0) {
        scopeGrid.shift();
        scopeGrid.push(scopeRandom(0));
      }
      scopeCtx.clearRect(0, 0, w, h);
      scopeCtx.fillStyle = getComputedStyle(document.documentElement).getPropertyValue('--color-signal').trim() || '#d92b2b';
      for (var c = 0; c < scopeCols; c++) {
        for (var r = 0; r < 2; r++) {
          if (scopeGrid[c] & (1 << r)) {
            scopeCtx.fillRect(c * cw + 1, 8 + r * (h / 2 - 4), cw - 2, h / 2 - 10);
          }
        }
      }
      if (!REDUCED) requestAnimationFrame(drawScope);
    }
    /* the tech panel is hidden (S57) — skip its canvas/matrix render loops
       entirely; telemetry text mirrors to the visible rail, so
       techUpdate/setSig keep running */
    var techVisuals = !!(tech && !tech.hasAttribute('hidden'));
    if (scopeCtx && techVisuals) { scopeInit(); drawScope(); }

    /* SIG telemetry drifts like a live feed; level bars track it */
    var sigEl = tech && tech.querySelector('[data-tech-sig]');
    var barsEl = tech && tech.querySelector('[data-tech-bars]');
    function setSig() {
      var v = 88 + Math.random() * 11.8;
      if (sigEl) sigEl.textContent = v.toFixed(1) + '%';
      var railSig = root.querySelector('[data-rail-sig]');
      if (railSig) railSig.textContent = v.toFixed(1) + '%';
      if (barsEl) {
        var on = Math.max(1, Math.round(((v - 88) / 12) * 5));
        barsEl.querySelectorAll('i').forEach(function (bar, i) {
          bar.classList.toggle('is-on', i < on);
        });
      }
    }
    if (sigEl || barsEl) {
      setSig();
      if (!REDUCED) setInterval(setSig, 2400);
    }

    if (tech) {
      if (techVisuals) buildMatrix();
      techUpdate(panes[0]);
    }

    function switchTo(id) {
      if (id < 1 || id > panes.length || id === current) return;
      var previous = root.querySelector('.konsole__pane:not([hidden])');
      current = id;
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-konsole-tab') === String(id);
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', String(on));
      });
      var active;
      panes.forEach(function (p) {
        var show = p.getAttribute('data-konsole-pane') === String(id);
        if (show) {
          active = p;
          p.hidden = false;
        } else if (p !== previous) {
          p.hidden = true;
        }
      });
      if (active) {
        /* Bayer dissolve — the previous look's image erodes into dithered
           noise over the incoming one; text decode-bursts alongside */
        if (previous && previous !== active) {
          if (REDUCED) {
            previous.hidden = true;
          } else {
            if (leavingPane && leavingPane !== previous) {
              leavingPane.hidden = true;
              leavingPane.classList.remove('is-leaving');
            }
            leavingPane = previous;
            previous.classList.add('is-leaving');
            setTimeout(function () {
              previous.hidden = true;
              previous.classList.remove('is-leaving');
              if (leavingPane === previous) leavingPane = null;
            }, 500);
          }
        }
        var wrap = active.querySelector('.konsole__imgwrap');
        var aImg = active.querySelector('[data-konsole-img]');
        var prevImg = previous && previous.querySelector('[data-konsole-img]');
        if (wrap && aImg && !REDUCED) {
          wrap.classList.add('is-arriving');
          dissolveSwap(wrap, aImg, aImg.getAttribute('src'), prevImg);
        }
        choreoPinsIn(active); // pins cascade back in once the wipe lands
        if (window.Loot && Loot.decode && Loot.decode.burst) {
          Loot.decode.burst(active);
        }
        techUpdate(active);
      }
    }

    /* ── image transition ─────────────────────────────────────────
       WebGL displacement wipe (elementis/lynxeye tier): both frames
       upload as textures, a procedural displacement field bends a
       left→right reveal whose edge is granular — a fine-noise dissolve
       eats ahead of the front, half-posterized for stepped, aliased
       bands. Incoming frame settles from a 1.08 zoom + slight rise,
       outgoing drifts to 1.07, chromatic split + grain live only
       inside the blend band, signal-red seam rides the front. The
       field is re-offset per swap so no two tears match. Contain-fit
       left-center mirrors the CSS exactly, and the canvas only leaves
       once the new <img> frame is decoded — zero pop, zero snap-back.
       Falls back to the Bayer dither below when WebGL/CORS fails. */
    var GL_VERT = [
      'attribute vec2 aPos;',
      'varying vec2 vUv;',
      'void main() { vUv = vec2(aPos.x * .5 + .5, aPos.y * .5 + .5); gl_Position = vec4(aPos, 0., 1.); }'
    ].join('\n');
    var GL_FRAG = [
      'precision highp float;',
      'varying vec2 vUv;',
      'uniform sampler2D uFrom;',
      'uniform sampler2D uTo;',
      'uniform sampler2D uDisp;',
      'uniform float uProgress;',
      'uniform vec2 uRes;',
      'uniform vec4 uFitF;',   // ox, oy, w, h — contain left-center, uv space
      'uniform vec4 uFitT;',
      'uniform vec3 uBg;',
      'uniform vec2 uDispOff;',   // per-swap field offset — every tear differs
      'vec4 pick(sampler2D tex, vec4 fit, vec2 uv, float zoom, vec2 warp, float dx) {',
      '  vec2 q = (uv - fit.xy) / fit.zw;',
      '  q = (q - .5) / zoom + .5;',
      '  q += warp;',
      '  q.x += dx;',
      '  if (q.x < 0. || q.x > 1. || q.y < 0. || q.y > 1.) return vec4(0.);',
      '  return texture2D(tex, q);',
      '}',
      'void main() {',
      '  float p = uProgress;',
      '  /* interlaced decoder wipe — 72 scan rows, odd rows lead, even',
      '     follow; 56 blocks per row flip in hash order like a buffer',
      '     filling. Sparse static fires from the first frame. */',
      '  float row = floor(vUv.y * 72.);',
      '  float parity = mod(row, 2.);',
      '  float order = vUv.y * .5 + parity * .5;',
      '  float rp = clamp(p * 1.5 - order * .5, 0., 1.);',
      '  float bx = floor(vUv.x * 56.);',
      '  float h = texture2D(uDisp, vec2((bx + .5) / 56., (row + .5) / 72.) * .9 + uDispOff * .3).r;',
      '  float m = step(h, rp) * step(.001, p);',
      '  m = max(m, step(h, p * .07) * step(.001, p));',   // scattered static ahead of the scan
      '  float fresh = (1. - smoothstep(.02, .12, rp - h)) * m * (1. - p);',
      '  float split = fresh * .012;',
      '  float zoomF = 1.;',
      '  float zoomT = 1. + .015 * (1. - p);',
      '  vec2 warpF = vec2(0.);',
      '  vec2 warpT = vec2((1. - rp) * (parity * 2. - 1.) * .03, 0.);',   // rows slide in, shutter-style
      '  vec4 aF = pick(uFrom, uFitF, vUv, zoomF, warpF, 0.);',
      '  vec4 aT = pick(uTo, uFitT, vUv, zoomT, warpT, 0.);',
      '  vec3 cF = vec3(pick(uFrom, uFitF, vUv, zoomF, warpF, split).r, aF.g, pick(uFrom, uFitF, vUv, zoomF, warpF, -split).b);',
      '  vec3 cT = vec3(pick(uTo, uFitT, vUv, zoomT, warpT, split).r, aT.g, pick(uTo, uFitT, vUv, zoomT, warpT, -split).b);',
      '  vec3 col = mix(cF, cT, m);',
      '  col = mix(uBg, col, mix(aF.a, aT.a, m));',
      '  float spark = fresh * step(.55, fract(h * 7.));',   // signal-red flash on fresh blocks
      '  col = mix(col, vec3(.851, .169, .169), spark * .5);',
      '  float g = fract(sin(dot(vUv * uRes, vec2(12.9898, 78.233))) * 43758.5453);',
      '  col += (g - .5) * .05 * sin(3.14159 * p);',
      '  gl_FragColor = vec4(col, 1.);',
      '}'
    ].join('\n');

    /* CORS-clean image cache — the CDN serves ACAO:*, so these upload
       straight to WebGL textures */
    var glImgCache = {};
    function glImg(src) {
      var c = glImgCache[src];
      if (c) return c;
      var im = new Image();
      im.crossOrigin = 'anonymous';
      var c2 = glImgCache[src] = { img: im, ok: false, failed: false };
      im.onload = function () { c2.ok = true; };
      im.onerror = function () { c2.failed = true; };
      im.src = src;
      return c2;
    }
    function glReady(c) {
      return new Promise(function (res) {
        if (c.ok || (c.img.complete && c.img.naturalWidth)) { c.ok = true; return res(true); }
        if (c.failed) return res(false);
        c.img.addEventListener('load', function () { res(true); });
        c.img.addEventListener('error', function () { res(false); });
      });
    }

    /* displacement field — layered smoothed value noise + faint
       horizontal streaks (scan bias), generated once */
    var dispCanvas = null;
    function getDispCanvas() {
      if (dispCanvas) return dispCanvas;
      var s = 256;
      var c = document.createElement('canvas');
      c.width = c.height = s;
      var x = c.getContext('2d');
      function octave(n, alpha, mode) {
        var t = document.createElement('canvas');
        t.width = t.height = n;
        var tx = t.getContext('2d');
        var id = tx.createImageData(n, n);
        for (var i = 0; i < id.data.length; i += 4) {
          var v = Math.floor(Math.random() * 256);
          id.data[i] = id.data[i + 1] = id.data[i + 2] = v;
          id.data[i + 3] = 255;
        }
        tx.putImageData(id, 0, 0);
        x.globalAlpha = alpha;
        x.globalCompositeOperation = mode;
        x.imageSmoothingEnabled = true;
        x.drawImage(t, 0, 0, s, s);
      }
      octave(8, 1, 'source-over');
      octave(24, 0.5, 'overlay');
      octave(96, 0.35, 'overlay');
      // horizontal streaks — the reveal tears along scan lines
      x.globalCompositeOperation = 'overlay';
      for (var ly = 0; ly < s; ly += 3) {
        x.globalAlpha = Math.random() * 0.14;
        x.fillStyle = Math.random() > 0.5 ? '#fff' : '#000';
        x.fillRect(0, ly, s, 1);
      }
      dispCanvas = c;
      return c;
    }

    /* one GL context per frame — program compiled once, textures
       cached; a swap is then just uniforms + a rAF loop, so the wipe
       starts in the same frame as the click. The canvas sits UNDER
       the HUD (z-index 1): pins, EXIF and the autobar keep living
       while the image morphs beneath them. */
    function initGL(wrap) {
      if (wrap._gl !== undefined) return wrap._gl;
      var cv = document.createElement('canvas');
      cv.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;z-index:1;pointer-events:none;visibility:hidden;';
      wrap.appendChild(cv);
      var gl = cv.getContext('webgl', { alpha: false, antialias: true });
      if (!gl) { cv.remove(); return (wrap._gl = null); }
      try {
        function sh(type, src) {
          var s = gl.createShader(type);
          gl.shaderSource(s, src);
          gl.compileShader(s);
          if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(s) || 'shader');
          return s;
        }
        var prog = gl.createProgram();
        gl.attachShader(prog, sh(gl.VERTEX_SHADER, GL_VERT));
        gl.attachShader(prog, sh(gl.FRAGMENT_SHADER, GL_FRAG));
        gl.linkProgram(prog);
        if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) throw new Error('link');
        gl.useProgram(prog);
        var buf = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, buf);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
        var loc = gl.getAttribLocation(prog, 'aPos');
        gl.enableVertexAttribArray(loc);
        gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
        var dispTex = gl.createTexture();
        gl.activeTexture(gl.TEXTURE2);
        gl.bindTexture(gl.TEXTURE_2D, dispTex);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, getDispCanvas());
        gl.uniform1i(gl.getUniformLocation(prog, 'uFrom'), 0);
        gl.uniform1i(gl.getUniformLocation(prog, 'uTo'), 1);
        gl.uniform1i(gl.getUniformLocation(prog, 'uDisp'), 2);
        wrap._gl = {
          cv: cv, gl: gl, prog: prog, dispTex: dispTex, texCache: {},
          uP: gl.getUniformLocation(prog, 'uProgress'),
          uRes: gl.getUniformLocation(prog, 'uRes'),
          uFitF: gl.getUniformLocation(prog, 'uFitF'),
          uFitT: gl.getUniformLocation(prog, 'uFitT'),
          uBg: gl.getUniformLocation(prog, 'uBg'),
          uDispOff: gl.getUniformLocation(prog, 'uDispOff')
        };
      } catch (e) {
        cv.remove();
        wrap._gl = null;
      }
      return wrap._gl;
    }

    /* texture cache — uploading a decoded image once per frame, never per swap */
    function glTex(st, img) {
      var key = img.currentSrc || img.src;
      var tx = st.texCache[key];
      if (!tx) {
        var gl = st.gl;
        tx = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, tx);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, img);
        st.texCache[key] = tx;
      }
      return tx;
    }

    function glSwap(wrap, img, fromC, toC, newSrc) {
      var st = initGL(wrap);
      if (!st) return false;
      var rect = wrap.getBoundingClientRect();
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var W = Math.max(1, Math.round(rect.width * dpr));
      var H = Math.max(1, Math.round(rect.height * dpr));
      if (st.cv.width !== W || st.cv.height !== H) {
        st.cv.width = W;
        st.cv.height = H;
      }
      var gl = st.gl;
      gl.viewport(0, 0, W, H);
      try {
        gl.activeTexture(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, glTex(st, fromC.img));
        gl.activeTexture(gl.TEXTURE1);
        gl.bindTexture(gl.TEXTURE_2D, glTex(st, toC.img));
        gl.activeTexture(gl.TEXTURE2);
        gl.bindTexture(gl.TEXTURE_2D, st.dispTex);
      } catch (e) {
        return false; // tainted source — caller falls back to the dither
      }
      gl.uniform2f(st.uRes, rect.width, rect.height);
      function fit(im) {
        var s = Math.min(rect.width / im.naturalWidth, rect.height / im.naturalHeight);
        var dh = im.naturalHeight * s;
        return [0, (rect.height - dh) / 2 / rect.height, im.naturalWidth * s / rect.width, dh / rect.height];
      }
      gl.uniform4fv(st.uFitF, fit(fromC.img));
      gl.uniform4fv(st.uFitT, fit(toC.img));
      /* background behind the contain margins — walk up to the first
         painted ancestor (theme-invert safe) */
      var bg = null, el = wrap;
      while (el && !bg) {
        var bcs = getComputedStyle(el).backgroundColor;
        var nums = bcs && bcs.match(/[\d.]+/g);
        if (nums && nums.length >= 3 && (nums.length < 4 || parseFloat(nums[3]) > 0)) {
          bg = [nums[0] / 255, nums[1] / 255, nums[2] / 255];
        }
        el = el.parentElement;
      }
      gl.uniform3fv(st.uBg, bg || [1, 1, 1]);
      gl.uniform2f(st.uDispOff, Math.random(), Math.random());
      gl.uniform1f(st.uP, 0);

      if (wrap._swap) wrap._swap.cancel();
      st.cv.style.visibility = 'visible';
      var raf = 0, dead = false, t0 = performance.now();
      /* linear — the decoder scan runs at machine tempo, no easing */
      function ease(t) { return t; }
      wrap._swap = {
        cancel: function () {
          dead = true;
          cancelAnimationFrame(raf);
          st.cv.style.visibility = 'hidden';
        }
      };
      (function frame(now) {
        if (dead) return;
        var raw = Math.min((now - t0) / SWAP_MS, 1);
        gl.uniform1f(st.uP, ease(raw));
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
        if (raw < 1) { raf = requestAnimationFrame(frame); return; }
        /* hand back to the <img> only once the incoming frame is
           decoded and painted — dropping early flashes the old image */
        if (newSrc && img.getAttribute('src') !== newSrc) {
          img.src = newSrc;
          img.removeAttribute('srcset');
        }
        var dropped = false;
        function drop() {
          if (dropped || dead) return;
          dropped = true;
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { st.cv.style.visibility = 'hidden'; });
          });
          if (wrap._swap && wrap._swap.cancel) wrap._swap = null;
        }
        var guard = setTimeout(drop, 500); // decode never resolves → drop anyway
        if (img.decode) {
          img.decode().then(function () {
            clearTimeout(guard);
            drop();
          }, function () {
            clearTimeout(guard);
            drop();
          });
        } else {
          drop();
        }
      })(t0);
      return true;
    }

    function dissolveSwap(wrap, img, newSrc, oldSrc) {
      if (REDUCED || !wrap) {
        if (newSrc && img.getAttribute('src') !== newSrc) {
          img.src = newSrc;
          img.removeAttribute('srcset');
        }
        return;
      }
      var rect = wrap.getBoundingClientRect();
      if (!rect.width || !newSrc) {
        if (newSrc) { img.src = newSrc; img.removeAttribute('srcset'); }
        return;
      }
      /* generation guard — a swap whose images finish loading after a
         newer swap started must not stomp it */
      var gen = wrap._gen = (wrap._gen || 0) + 1;
      /* FROM frame: prefer the element already displaying it (loaded
         with crossorigin, so it uploads straight to a texture) */
      var fromC;
      if (oldSrc && oldSrc.tagName === 'IMG') {
        fromC = (oldSrc.complete && oldSrc.naturalWidth)
          ? { img: oldSrc, ok: true }
          : glImg(oldSrc.currentSrc || oldSrc.src);
      } else if (oldSrc && oldSrc !== img.getAttribute('src')) {
        fromC = glImg(oldSrc);
      } else {
        fromC = { img: img, ok: true };
      }
      var toC = newSrc === img.getAttribute('src') ? { img: img, ok: true } : glImg(newSrc);
      Promise.all([glReady(fromC), glReady(toC)]).then(function (oks) {
        if (wrap._gen !== gen) return; // superseded while loading
        if (oks[0] && oks[1] && glSwap(wrap, img, fromC, toC, newSrc)) return;
        ditherSwap(wrap, img, newSrc,
          typeof oldSrc === 'string' ? oldSrc : oldSrc && oldSrc.getAttribute('src'));
      });
    }

    /* Bayer dither — fallback when WebGL/CORS is unavailable: the
       outgoing image is eaten by ordered-dither noise (8x8 Bayer +
       jitter), revealing the incoming one; a red shimmer trails the
       erase edge. Canvas, ~520ms, no DOM blocks. */
    var BAYER = [
      0, 32, 8, 40, 2, 34, 10, 42, 48, 16, 56, 24, 50, 18, 58, 26,
      12, 44, 4, 36, 14, 46, 6, 38, 60, 28, 52, 20, 62, 30, 54, 22,
      3, 35, 11, 43, 1, 33, 9, 41, 51, 19, 59, 27, 49, 17, 57, 25,
      15, 47, 7, 39, 13, 45, 5, 37, 63, 31, 55, 23, 61, 29, 53, 21
    ];

    function ditherSwap(wrap, img, newSrc, oldSrc) {
      if (REDUCED || !wrap) {
        if (newSrc && img.getAttribute('src') !== newSrc) {
          img.src = newSrc;
          img.removeAttribute('srcset');
        }
        return;
      }
      var rect = wrap.getBoundingClientRect();
      if (!rect.width) { img.src = newSrc; return; }

      // the outgoing frame — the displayed img, or oldSrc from cache
      var from = img;
      if (oldSrc && img.getAttribute('src') !== oldSrc) {
        from = new Image();
        from.src = oldSrc;
      }

      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var cv = document.createElement('canvas');
      cv.width = Math.round(rect.width * dpr);
      cv.height = Math.round(rect.height * dpr);
      cv.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;z-index:3;pointer-events:none;';
      var ctx = cv.getContext('2d');
      ctx.scale(dpr, dpr);
      ctx.imageSmoothingEnabled = false;

      // coarse jittered Bayer mask
      var mw = 200, mh = Math.max(1, Math.round(200 * rect.height / rect.width));
      var bayer = new Uint8Array(mw * mh);
      for (var y = 0; y < mh; y++) {
        for (var x = 0; x < mw; x++) {
          bayer[y * mw + x] = BAYER[(y % 8) * 8 + (x % 8)] + (Math.random() * 8 - 4);
        }
      }
      var maskCv = document.createElement('canvas');
      maskCv.width = mw;
      maskCv.height = mh;
      var maskCtx = maskCv.getContext('2d');

      // paint the outgoing frame exactly as displayed (contain, left-center)
      var iw = from.naturalWidth, ih = from.naturalHeight;
      if (iw && ih) {
        var scale = Math.min(rect.width / iw, rect.height / ih);
        var dh = ih * scale;
        ctx.drawImage(from, 0, (rect.height - dh) / 2, iw * scale, dh);
      }
      wrap.appendChild(cv);

      img.src = newSrc;
      img.removeAttribute('srcset');

      var t0 = performance.now(), DUR = 520, EDGE = 10;
      (function step(now) {
        var p = Math.min((now - t0) / DUR, 1);
        var thr = p * 72;
        var maskImg = maskCtx.createImageData(mw, mh);
        var d = maskImg.data;
        var i, j;
        for (i = 0; i < bayer.length; i++) {
          j = i * 4 + 3;
          d[j] = bayer[i] < thr ? 255 : 0; // erase zone
        }
        maskCtx.putImageData(maskImg, 0, 0);
        ctx.globalCompositeOperation = 'destination-out';
        ctx.drawImage(maskCv, 0, 0, rect.width, rect.height);
        // red shimmer in the freshly-erased band
        var band = maskCtx.createImageData(mw, mh);
        var bd = band.data;
        for (i = 0; i < bayer.length; i++) {
          if (bayer[i] >= thr && bayer[i] < thr + EDGE) {
            j = i * 4;
            bd[j] = 217; bd[j + 1] = 43; bd[j + 2] = 43; bd[j + 3] = 220;
          }
        }
        maskCtx.putImageData(band, 0, 0);
        ctx.globalCompositeOperation = 'destination-over';
        ctx.drawImage(maskCv, 0, 0, rect.width, rect.height);
        ctx.globalCompositeOperation = 'source-over';
        if (p < 1) requestAnimationFrame(step);
        else cv.remove();
      })(t0);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        switchTo(parseInt(tab.getAttribute('data-konsole-tab'), 10));
      });
    });

    // arrow keys — the looks cycle like camera channels
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      if (e.target.matches('input, textarea, select')) return;
      var rect = root.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return; // only while visible
      var dir = e.key === 'ArrowRight' ? 1 : -1;
      var next = ((current - 1 + dir + panes.length) % panes.length) + 1;
      switchTo(next);
    });

    // object row <-> marker lock-on sync (scoped per pane)
    panes.forEach(function (pane) {
      function wire(hoverSel, targetSel) {
        pane.querySelectorAll(hoverSel).forEach(function (el) {
          var id = el.getAttribute('data-obj');
          var mate = pane.querySelector(targetSel + '[data-obj="' + id + '"]');
          if (!mate) return;
          el.addEventListener('mouseenter', function () {
            el.classList.add('is-locked');
            mate.classList.add('is-locked');
          });
          el.addEventListener('mouseleave', function () {
            el.classList.remove('is-locked');
            mate.classList.remove('is-locked');
          });
        });
      }
      wire('.konsole__row', '.konsole__marker');
      wire('.konsole__marker', '.konsole__row');
    });

    // cursor thumbnail — rows and pins carry data-preview; a fixed frame
    // follows the pointer with the garment. Direct follow, no lerp.
    var preview = root.querySelector('.konsole__preview');
    if (preview && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var previewImg = preview.querySelector('img');
      var OFFSET = 14;

      function placePreview(x, y) {
        var w = preview.offsetWidth;
        var h = preview.offsetHeight;
        var left = x + OFFSET;
        if (left + w > window.innerWidth - 8) left = x - w - OFFSET;
        var top = Math.max(8, Math.min(y - h / 2, window.innerHeight - h - 8));
        preview.style.transform = 'translate(' + left + 'px,' + top + 'px)';
      }

      root.querySelectorAll('[data-preview]').forEach(function (el) {
        el.addEventListener('mouseenter', function (e) {
          var src = el.getAttribute('data-preview');
          if (!src) return;
          if (previewImg.getAttribute('src') !== src) previewImg.setAttribute('src', src);
          preview.hidden = false;
          placePreview(e.clientX, e.clientY);
        });
        el.addEventListener('mousemove', function (e) {
          if (!preview.hidden) placePreview(e.clientX, e.clientY);
        });
        el.addEventListener('mouseleave', function () { preview.hidden = true; });
      });
      // panes swap — hide so a stale thumb never survives a tab switch
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () { preview.hidden = true; });
      });
    }

    /* FULL / TOP / BTM detail views — pixel-dissolve swap; pins and rows
       filter per view (absent items drop out of both) */
    var VIEWS = ['full', 'top', 'bot'];

    function setView(pane, view) {
      var wrap = pane.querySelector('[data-views]');
      if (!wrap || wrap.getAttribute('data-active-view') === view) return;
      wrap.setAttribute('data-active-view', view);
      pane.querySelectorAll('[data-view-btn]').forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-view-btn') === view);
      });
      var img = pane.querySelector('[data-konsole-img]');
      var oldSrc = img.getAttribute('src');
      var newSrc = wrap.getAttribute('data-view-' + view);

      var label = pane.querySelector('[data-view-label]');
      var labelText = view === 'bot' ? 'BTM' : view.toUpperCase();
      label.textContent = labelText;
      label.setAttribute('data-decode-text', labelText);

      // rows filter instantly; pins get the staggered reshuffle
      pane.querySelectorAll('.konsole__row').forEach(function (el) {
        var inView = view === 'full' || el.getAttribute('data-in-' + view) === 'true';
        el.classList.toggle('is-out', !inView);
      });
      choreoPins(pane, view);

      if (!REDUCED) dissolveSwap(wrap, img, newSrc, oldSrc);
      else { img.src = newSrc; img.removeAttribute('srcset'); }
      if (window.Loot && Loot.decode && Loot.decode.burst) Loot.decode.burst(pane);
      if (preview) preview.hidden = true;
    }

    /* pins leave one after another at click; the new view's pins only
       come back AFTER the image transition completes (SWAP_MS), in the
       same cascade — a full re-acquisition, not a reshuffle. A per-pane
       generation guard kills stale timers on rapid view switches. */
    function choreoPins(pane, view) {
      var gen = pane._pinGen = (pane._pinGen || 0) + 1;
      var exiting = [], staying = [];
      pane.querySelectorAll('.konsole__marker').forEach(function (el) {
        var inView = view === 'full' || el.getAttribute('data-in-' + view) === 'true';
        if (inView) staying.push(el);
        if (!el.classList.contains('is-out')) exiting.push(el);
      });
      function place(el) {
        el.classList.remove('is-exiting');
        el.style.setProperty('--tag-x', el.getAttribute('data-' + view + '-x') + '%');
        el.style.setProperty('--tag-y', el.getAttribute('data-' + view + '-y') + '%');
        el.classList.remove('is-out');
      }
      if (REDUCED) {
        staying.forEach(place);
        exiting.forEach(function (el) { el.classList.add('is-out'); });
        return;
      }
      var STEP = 100;
      exiting.forEach(function (el, i) {
        setTimeout(function () {
          if (pane._pinGen !== gen) return;
          el.classList.add('is-exiting');
          setTimeout(function () {
            el.classList.remove('is-exiting');
            if (pane._pinGen !== gen) return;
            el.classList.add('is-out');
          }, 220);
        }, i * STEP);
      });
      var base = SWAP_MS + 100; // entrances wait for the wipe to finish
      staying.forEach(function (el, i) {
        setTimeout(function () {
          if (pane._pinGen !== gen) return;
          place(el);
        }, base + i * STEP);
      });
    }

    /* channel switch (LOOK tabs): the incoming pane's pins stay hidden
       through the wipe, then cascade in — same re-acquisition rhythm */
    function choreoPinsIn(pane) {
      var wrap = pane.querySelector('[data-views]');
      var view = (wrap && wrap.getAttribute('data-active-view')) || 'full';
      var gen = pane._pinGen = (pane._pinGen || 0) + 1;
      var incoming = [];
      pane.querySelectorAll('.konsole__marker').forEach(function (el) {
        var inView = view === 'full' || el.getAttribute('data-in-' + view) === 'true';
        el.classList.add('is-out');
        if (inView) incoming.push(el);
      });
      if (REDUCED) {
        incoming.forEach(function (el) { el.classList.remove('is-out'); });
        return;
      }
      incoming.forEach(function (el, i) {
        setTimeout(function () {
          if (pane._pinGen !== gen) return;
          el.classList.remove('is-out');
        }, SWAP_MS + 100 + i * 100);
      });
    }

    panes.forEach(function (pane, pi) {
      var wrap = pane.querySelector('[data-views]');
      if (!wrap) return;
      // preload detail views (CORS-clean) so swaps never hit the network
      ['top', 'bot'].forEach(function (v) {
        glImg(wrap.getAttribute('data-view-' + v));
      });
      // warm the GL context (compile + disp texture) — the first click
      // must start the wipe in the same frame, not after a compile stall.
      // Pane 1 warms immediately; the rest warm on idle to keep boot cheap.
      if (pi === 0) initGL(wrap);
      else setTimeout(function () { initGL(wrap); }, 1500);
      pane.querySelectorAll('[data-view-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setView(pane, btn.getAttribute('data-view-btn'));
          autoTimerReset();
        });
      });
    });

    /* auto-cycle the views while the console is on screen and untouched */
    var autoTimer = null;
    function autobarRun() {
      var pane = root.querySelector('.konsole__pane:not([hidden])');
      var bar = pane && pane.querySelector('.konsole__autobar');
      if (!bar) return;
      bar.classList.remove('is-running');
      void bar.offsetWidth;
      if (!REDUCED) bar.classList.add('is-running');
    }
    function autoTimerReset() {
      if (autoTimer) clearInterval(autoTimer);
      if (REDUCED) return;
      autobarRun();
      autoTimer = setInterval(function () {
        if (document.hidden) return;
        var rect = root.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        var pane = root.querySelector('.konsole__pane:not([hidden])');
        if (!pane || !pane.querySelector('[data-views]')) return;
        var wrap = pane.querySelector('[data-views]');
        var cur = wrap.getAttribute('data-active-view') || 'full';
        var next = VIEWS[(VIEWS.indexOf(cur) + 1) % VIEWS.length];
        setView(pane, next);
        autobarRun();
      }, 4500);
    }
    autoTimerReset();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["network-map"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-netmap]');
    if (!section) return;

    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var SVG_NS = 'http://www.w3.org/2000/svg';
    var svg = section.querySelector('[data-netmap-svg]');
    var sysline = section.querySelector('[data-netmap-sysline]');
    var rowsBox = section.querySelector('[data-netmap-rows]');
    var hint = section.querySelector('[data-netmap-hint]');

    var nodes = [];
    try {
      nodes = JSON.parse(section.querySelector('[data-netmap-nodes]').textContent);
    } catch (e) { return; }
    if (!nodes.length) return;

    function proj(lat, lon) {
      return { x: (lon + 180) / 360 * 2000, y: (90 - lat) / 180 * 1000 };
    }

    function el(tag, attrs) {
      var n = document.createElementNS(SVG_NS, tag);
      for (var k in attrs) n.setAttribute(k, attrs[k]);
      return n;
    }

    function fmtCoord(v, pos, neg, pad) {
      var parts = Math.abs(v).toFixed(2).split('.');
      var i = parts[0];
      while (i.length < pad) i = '0' + i;
      return i + '.' + parts[1] + (v >= 0 ? pos : neg);
    }

    function setText(elm, text) {
      elm.textContent = text;
      // decode caches the settled text on the element — refresh it or the
      // burst re-decodes to the stale original
      elm.setAttribute('data-decode-text', text);
    }

    /* ── dots (column groups for the sweep-delay reveal) ── */
    function buildDots() {
      var rows = window.LOOT_WORLD_DOTS || [];
      var cols = {};
      rows.forEach(function (bits, r) {
        if (r * 10 + 5 > 840) return; // below the crop
        for (var c = 0; c < bits.length; c++) {
          if (bits.charAt(c) !== '1') continue;
          if (!cols[c]) {
            cols[c] = el('g', { 'class': 'netmap__dots-col' });
            if (!REDUCED) cols[c].style.transitionDelay = (c * 2.2) + 'ms';
            svg.appendChild(cols[c]);
          }
          cols[c].appendChild(el('circle', { 'class': 'netmap__dot', cx: c * 10 + 5, cy: r * 10 + 5, r: 1.7 }));
        }
      });
    }

    /* ── arcs between hub nodes (block order) ── */
    function buildArcs() {
      var hubs = nodes.filter(function (n) { return n.hub; });
      for (var i = 0; i < hubs.length - 1; i++) {
        var a = proj(hubs[i].lat, hubs[i].lon);
        var b = proj(hubs[i + 1].lat, hubs[i + 1].lon);
        var mx = (a.x + b.x) / 2;
        var my = Math.min(a.y, b.y) - Math.abs(b.x - a.x) * 0.18;
        svg.appendChild(el('path', {
          'class': 'netmap__arc',
          d: 'M' + a.x + ' ' + a.y + ' Q' + mx + ' ' + my + ' ' + b.x + ' ' + b.y
        }));
      }
    }

    /* ── markers ── */
    var markers = [];
    function buildMarkers() {
      nodes.forEach(function (node, i) {
        var p = proj(node.lat, node.lon);
        var g = el('g', { 'class': 'netmap__marker', 'data-node': i, tabindex: '0', role: 'button', 'aria-label': node.city });
        g.setAttribute('transform', 'translate(' + p.x + ' ' + p.y + ')');

        var size = node.hub ? 16 : 11;
        var b = el('path', {
          'class': 'netmap__marker-brackets',
          d: 'M' + (-size) + ' ' + (-size + 7) + ' L' + (-size) + ' ' + (-size) + ' L' + (-size + 7) + ' ' + (-size) +
             ' M' + (size - 7) + ' ' + (-size) + ' L' + size + ' ' + (-size) + ' L' + size + ' ' + (-size + 7) +
             ' M' + size + ' ' + (size - 7) + ' L' + size + ' ' + size + ' L' + (size - 7) + ' ' + size +
             ' M' + (-size + 7) + ' ' + size + ' L' + (-size) + ' ' + size + ' L' + (-size) + ' ' + (size - 7)
        });
        g.appendChild(b);

        g.appendChild(el('circle', { 'class': 'netmap__marker-pulse', cx: 0, cy: 0, r: size }));

        g.appendChild(el('path', {
          'class': 'netmap__marker-core',
          d: 'M-4.5 0 H4.5 M0 -4.5 V4.5',
          stroke: 'currentColor',
          'stroke-width': 2,
          fill: 'none'
        }));

        if (node.hub) {
          // alternate label side by hub ordinal — dense hubs (PARIS/ANTWERP)
          // would otherwise print over each other
          var hubOrdinal = markers.filter(function (m) { return m.__hub; }).length;
          g.__hub = true;
          var below = hubOrdinal % 2 === 1;
          var label = el('text', {
            'class': 'netmap__marker-label',
            x: size + 8,
            y: below ? size + 16 : -size + 4
          });
          label.textContent = node.city.toUpperCase();
          g.appendChild(label);
        }

        // invisible hit disc, sized to the marker; resolveOverlaps() shrinks
        // any pair that would shadow a neighbour (Milan/Florence)
        g.appendChild(el('circle', { cx: 0, cy: 0, r: 13, fill: 'transparent' }));

        svg.appendChild(g);
        markers.push(g);

        g.addEventListener('mouseenter', function () { activate(i, g); });
        g.addEventListener('focus', function () { activate(i, g); });
        g.addEventListener('click', function () { activate(i, g); });
        g.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(i, g); }
        });
      });
    }

    /* shrink hit circles where markers crowd (Milan/Florence) so each keeps
       a unique hover zone; bracket strokes stay hoverable beyond the disc */
    function resolveOverlaps() {
      var hits = markers.map(function (g) { return g.querySelector('circle[fill="transparent"]'); });
      for (var i = 0; i < markers.length; i++) {
        for (var j = i + 1; j < markers.length; j++) {
          var a = proj(nodes[i].lat, nodes[i].lon);
          var b = proj(nodes[j].lat, nodes[j].lon);
          var d = Math.hypot(a.x - b.x, a.y - b.y);
          if (d < 28) {
            var r = Math.max(8, d / 2 - 1);
            if (parseFloat(hits[i].getAttribute('r')) > r) hits[i].setAttribute('r', r);
            if (parseFloat(hits[j].getAttribute('r')) > r) hits[j].setAttribute('r', r);
          }
        }
      }
    }

    /* ── readout ── */
    var savedDefault = null;

    function activate(i, g) {
      // capture the pristine summary on first lock — before we overwrite it,
      // and after Loot.decode has settled (it caches text per element)
      if (!savedDefault) {
        savedDefault = {
          rows: rowsBox.innerHTML,
          sys: sysline.getAttribute('data-decode-text') || sysline.textContent
        };
      }
      markers.forEach(function (m) { m.classList.remove('is-active'); });
      g.classList.add('is-active');

      var node = nodes[i];
      setText(sysline, '> NODE_' + ('0' + (i + 1)).slice(-2) + ' LOCKED // ' + node.city.toUpperCase());

      var html = '';
      html += row('LOC', esc(node.city.toUpperCase()) + ' / ' + esc(node.cc.toUpperCase()), true);
      html += row('COORD', fmtCoord(node.lat, 'N', 'S', 2) + ' / ' + fmtCoord(node.lon, 'E', 'W', 3), true);
      node.lines.forEach(function (line, j) {
        var idx = '<span class="netmap__idx">' + ('0' + (j + 1)).slice(-2) + ' · </span>';
        // brand rows carry live links — no data-decode here, the scramble
        // rewrites textContent and would destroy the anchor
        var val = line.url
          ? idx + '<a class="netmap__brand" href="' + line.url + '">' + esc(line.name.toUpperCase()) + ' →</a>'
          : idx + esc(line.name.toUpperCase());
        html += row(j === 0 ? 'DESIGNERS' : '', val, false);
      });
      rowsBox.innerHTML = html;
      if (hint) hint.hidden = true;
      if (window.Loot && Loot.decode && Loot.decode.burst) Loot.decode.burst(section);
    }

    function row(key, valHtml, decode) {
      return '<p class="netmap__row"><span class="netmap__key">' + key + '</span><span' +
        (decode ? ' data-decode' : '') + '>' + valHtml + '</span></p>';
    }

    function esc(s) {
      var d = document.createElement('div');
      d.textContent = s || '';
      return d.innerHTML;
    }

    function reset() {
      if (!savedDefault) return;
      markers.forEach(function (m) { m.classList.remove('is-active'); });
      rowsBox.innerHTML = savedDefault.rows;
      setText(sysline, savedDefault.sys);
      if (hint) hint.hidden = false;
    }

    // leaving the whole stage restores the network summary (map ↔ console
    // travel must not reset — the readout links live in the console)
    section.querySelector('.netmap__stage').addEventListener('mouseleave', reset);

    /* ── boot: wait for the dots data (asset script order is not ours) ── */
    var tries = 0;
    function boot() {
      if (!window.LOOT_WORLD_DOTS) {
        if (tries++ < 40) return setTimeout(boot, 100);
        return;
      }
      buildDots();
      buildArcs();
      buildMarkers();
      resolveOverlaps();

      if (REDUCED) {
        section.classList.add('is-live');
      } else {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              section.classList.add('is-live');
              io.disconnect();
            }
          });
        }, { threshold: 0.25 });
        io.observe(section);
      }
    }
    boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  (function () {
    var video = document.querySelector('.pw__media');
    if (!video) return;
    var stage = video.closest('.pw');
    video.defaultMuted = true;
    video.muted = true;
    video.addEventListener('playing', function () { stage.classList.add('is-rolling'); });
    video.addEventListener('pause', function () { stage.classList.remove('is-rolling'); });
    function play() {
      if (!video.paused) {
        if (video.readyState >= 2) stage.classList.add('is-rolling');
        return;
      }
      video.muted = true;
      var attempt = video.play();
      if (attempt && attempt.catch) attempt.catch(function () {});
    }
    video.addEventListener('canplay', play);
    window.addEventListener('pageshow', play);
    window.addEventListener('pointerdown', play, { once: true, passive: true });
    window.addEventListener('touchend', play, { once: true, passive: true });
    play();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var form = document.querySelector('[data-pdp-form]');
    if (!form) return;
    var feedback = document.querySelector('[data-pdp-feedback]');
    var variantSelect = form.querySelector('[data-pdp-variant]');
    var idInput = form.querySelector('input[name="id"]');
    var btn = form.querySelector('button[type="submit"]');

    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        idInput.value = variantSelect.value;
      });
    }

    function say(msg, ok) {
      if (!feedback) return;
      feedback.textContent = msg;
      feedback.hidden = false;
      feedback.classList.toggle('is-error', !ok);
      feedback.classList.toggle('is-ok', !!ok);
    }

    // 1/1 guard: once this variant is in the visitor's cart, the buy button
    // locks (checkout is the final enforcer against cross-buyer races).
    function lockIfInCart() {
      return fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          // both cart badges (header bar + menu overlay) must stay in sync
          var badge = cart.item_count > 0 ? '&nbsp;(' + cart.item_count + ')' : '';
          document.querySelectorAll('[data-cart-count]').forEach(function (count) {
            count.innerHTML = badge;
          });
          var inCart = cart.items.some(function (i) { return i.variant_id === Number(idInput.value); });
          if (inCart) {
            btn.disabled = true;
            btn.classList.add('is-incart');
            btn.textContent = form.getAttribute('data-label-incart') || 'IN YOUR CART';
          }
          return inCart;
        });
    }

    lockIfInCart();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      // drop gate: refuse adds while the unlock time is still ahead
      var until = Number(form.getAttribute('data-drop-until') || 0) * 1000;
      if (until && Date.now() < until) return;
      btn.disabled = true;
      lockIfInCart().then(function (already) {
        if (already) return;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: Number(idInput.value), quantity: 1 }),
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            if (res.ok) {
              say(form.getAttribute('data-msg-added') || '> ADDED TO CART_', true);
              return lockIfInCart();
            }
            say('> ' + ((res.d && (res.d.description || res.d.message)) || 'ERROR') + '_', false);
            btn.disabled = false;
          });
      })
        .catch(function () { say('> NETWORK ERROR_', false); btn.disabled = false; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  /* infinite results — same streaming grammar as the catalog: pages are
     prefetched before they're needed, appended results reveal per-piece,
     and the pagination nav stays in the DOM as the no-JS fallback. */
  (function () {
    var section = document.querySelector('.search');
    if (!section) return;
    var sentinel = section.querySelector('[data-sentinel]');
    if (!sentinel) return;

    var pgnav = section.querySelector('.search__pagination');
    if (pgnav) pgnav.hidden = true;
    var sentinelText = sentinel.querySelector('[data-sentinel-text]');
    var toTop = sentinel.querySelector('[data-to-top]');
    if (toTop) {
      toTop.addEventListener('click', function () {
        var lenis = window.Loot && Loot.scroll && Loot.scroll.instance;
        if (lenis) lenis.scrollTo(0);
        else window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    var grid = section.querySelector('.search__grid');
    var logs = section.querySelector('.search__logs');
    var nextPage = 2;
    var loading = false;
    var done = false;
    var buffered = null;

    /* appended results fade/rise one by one, same grammar as Loot.reveal */
    var revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-faded-in');
        revealIO.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });

    function fetchPage(n) {
      var u = new URL(window.location.href);
      u.searchParams.set('page', n);
      return fetch(u.toString(), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return {
            items: doc.querySelectorAll('.search__grid > li'),
            logs: doc.querySelectorAll('.search__logs > li')
          };
        });
    }

    /* the next page is always in flight before the reader reaches it */
    function prefetch() {
      if (done || buffered) return;
      fetchPage(nextPage)
        .then(function (data) { buffered = data; })
        .catch(function () {});
    }

    function appendBuffered() {
      if (!buffered) return;
      if (!buffered.items.length && !buffered.logs.length) {
        done = true;
        if (sentinelText) sentinelText.textContent = sentinelText.getAttribute('data-end') || 'END OF INVENTORY';
        if (toTop) toTop.hidden = false;
        io.disconnect();
        return;
      }
      /* a later page can hold products even if page 1 didn't (and vice
         versa) — create the target list on demand, before the sentinel */
      if (buffered.items.length && !grid) {
        grid = document.createElement('ul');
        grid.className = 'search__grid';
        grid.setAttribute('role', 'list');
        section.insertBefore(grid, sentinel);
      }
      if (buffered.logs.length && !logs) {
        logs = document.createElement('ul');
        logs.className = 'search__logs';
        logs.setAttribute('role', 'list');
        section.insertBefore(logs, sentinel);
      }
      buffered.items.forEach(function (li) {
        grid.appendChild(li);
        revealIO.observe(li);
      });
      buffered.logs.forEach(function (li) {
        logs.appendChild(li);
        revealIO.observe(li);
      });
      buffered = null;
      nextPage++;
      if (window.Loot && Loot.dropgate) Loot.dropgate.refresh();
      prefetch();
      /* keep filling while the sentinel sits near the viewport — the
         observer won't re-fire on its own if we never left it */
      var sr = sentinel.getBoundingClientRect();
      if (!done && sr.top < window.innerHeight * 1.55) stream();
    }

    function stream() {
      if (loading || done) return;
      if (buffered) { appendBuffered(); return; }
      loading = true;
      if (sentinelText) sentinelText.textContent = '···';
      fetchPage(nextPage)
        .then(function (data) {
          buffered = data;
          loading = false;
          appendBuffered();
        })
        .catch(function () { loading = false; });
    }

    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) stream();
    }, { rootMargin: '0px 0px 55% 0px' });
    io.observe(sentinel);
    prefetch();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wardrobe-index"]) return;
  try {
    
  (function () {
    /* continuous archive — the shop's streaming system: prefetch the next
       page, append cells as the reader nears the sentinel, reveal each
       cell as it enters the viewport, init the strips on arrival. */
    var wrap = document.querySelector('.wfatx');
    if (!wrap) return;
    var sentinel = wrap.querySelector('[data-wfat-sentinel]');
    if (!sentinel) return;
    var pgnav = wrap.querySelector('.wfatx__pagination');
    if (pgnav) pgnav.hidden = true;
    var sentinelText = sentinel.querySelector('[data-wfat-sentinel-text]');
    var grid = wrap.querySelector('[data-wfat-grid]');
    var nextPage = 2;
    var loading = false;
    var done = false;
    var buffered = null;
    var appending = false;

    var revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-faded-in');
        // THE 5-report bug: Loot.reveal only registers [data-fade] present
        // at boot — a streamed cell's NESTED faders (the strip: bar, track,
        // images) stayed at opacity 0 forever, leaving strip-height blank
        // rows under visible captions. Reveal every nested fader with the
        // cell.
        entry.target.querySelectorAll('[data-fade]').forEach(function (el) {
          el.classList.add('is-faded-in');
        });
        revealIO.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });

    function fetchPage(n) {
      var u = new URL(window.location.href);
      u.searchParams.set('page', n);
      /* no-store: Safari otherwise serves stale cached page fetches across
         deploys — streamed rows then show yesterday's markup */
      return fetch(u.toString(), { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) {
          if (!r.ok) throw new Error('page fetch ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          // an error/interstitial page has no grid — that is a failure,
          // NOT the end of the archive (empty grid = genuine end)
          var g = doc.querySelector('[data-wfat-grid]');
          if (!g) throw new Error('no grid in response');
          return { items: g.querySelectorAll(':scope > article') };
        });
    }

    function prefetch() {
      if (done || buffered) return;
      fetchPage(nextPage)
        .then(function (data) { buffered = data; })
        .catch(function () {});
    }

    function appendBuffered() {
      if (!buffered || appending) return;
      if (!buffered.items.length) {
        done = true;
        if (sentinelText) sentinelText.textContent = sentinelText.getAttribute('data-end') || 'END OF WARDROBE';
        io.disconnect();
        return;
      }
      // S124 mobile perf: a whole 16-strip page parsed + laid out in ONE
      // shot froze frames mid-momentum-scroll on phones (felt like
      // jitter / micro-jumps — iOS has no scroll anchoring to hide a
      // dropped frame). Rows now land in small chunks, one batch per
      // animation frame, so no single frame carries more than 3 rows.
      //
      // Re-serialization via insertAdjacentHTML (S115c) births elements
      // in the LIVE document, so native loading=lazy works normally in
      // Safari again — streamed images KEEP it and load only as they
      // approach the viewport, instead of ~60 eager downloads per page
      // competing with the scroll. (The old removeAttribute('loading')
      // was the fix for DOMParser-ADOPTED nodes, a path that no longer
      // exists. Verified by pixels: deep streamed rows render loaded,
      // opacity 1.)
      var cells = Array.prototype.slice.call(buffered.items);
      buffered = null;
      nextPage++;
      appending = true;
      var CHUNK = 3;
      function step() {
        var batch = cells.splice(0, CHUNK);
        batch.forEach(function (cell) {
          grid.insertAdjacentHTML('beforeend', cell.outerHTML);
          revealIO.observe(grid.lastElementChild);
        });
        if (window.Loot && Loot.strip) Loot.strip.init(); // idempotent — new strips only
        if (cells.length) {
          requestAnimationFrame(step);
          return;
        }
        appending = false;
        prefetch();
        var sr = sentinel.getBoundingClientRect();
        if (!done && sr.top < window.innerHeight * 1.9) stream();
      }
      requestAnimationFrame(step);
    }

    function stream() {
      if (loading || done || appending) return;
      if (buffered) { appendBuffered(); return; }
      loading = true;
      if (sentinelText) sentinelText.textContent = '···';
      fetchPage(nextPage)
        .then(function (data) {
          buffered = data;
          loading = false;
          appendBuffered();
        })
        .catch(function () {
          // a failed fetch must not strand the stream: the sentinel is
          // usually still in view, so the IO never re-fires — retry on
          // a timer while the reader is parked at the boundary
          loading = false;
          setTimeout(function () {
            var sr = sentinel.getBoundingClientRect();
            if (!done && !loading && sr.top < window.innerHeight * 1.9) stream();
          }, 1500);
        });
    }

    // trigger a full screen early (S124): chunked appends then finish
    // well below the fold, so the visible region never changes mid-scroll
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) stream();
    }, { rootMargin: '0px 0px 100% 0px' });
    io.observe(sentinel);
    prefetch();
  })();

  } catch(e) { console.error(e); }
})();
})();
